export const GET_TOP_PICKS = 'getTopPicks';